import { jsx } from "react/jsx-runtime";
import cn from "clsx";
function Code({
  children,
  className,
  "data-language": _language,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    "code",
    {
      className: cn(
        "nextra-code",
        "data-line-numbers" in props && "[counter-reset:line]",
        className
      ),
      dir: "ltr",
      ...props,
      children
    }
  );
}
export {
  Code
};
